import { IState } from '..';

export const selectAriaLiveAnnouncements = (state: IState) =>
  state.accessibility.ariaLive.announcements;
